define(function (require) {

    window.lpTag = window.lpTag || {};

    var App = window.App || {};
    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var HeaderViewController = require('web-agent-viewControllers/HeaderViewController');
    var EngagementAreaViewController = require('web-agent-viewControllers/EngagementAreaViewController');
    var FooterViewController = require('web-agent-viewControllers/FooterViewController');
    var TabsManagerViewController = require('web-agent-viewControllers/TabsManagerViewController');
    var PhotoPreviewViewController = require('web-agent-viewControllers/PhotoPreviewViewController');
    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var MainViewController = ViewController.extend({
        ControllerName: "MainViewController",

        initialize: function (constructorData) {
            this.MAX_FOCUS_QUEUE = 20; // TODO: Make the focus queue limited by size.
            this.participants = [];
            this.focusQueue = [];
            this.focusedIndex = -1;
            this.autoLogin = constructorData.autoLogin;
            this.touchSessionMethod = constructorData.touchSession;
            this.fragmentDocument = document.createDocumentFragment();
            this.registerShortcut(this.shortcutType.LOGOUT, this.logout);
        },

        events: function () {
            this.bindModel({modelPath : "participants.myEngagements", callback : this.handleNewParticipant});
            this.bindModel({modelPath : "participants.simulatedEngagements", callback : this.handleNewParticipant});
            this.bindModel({modelPath : "agent.status", callback : this.statusChanged});
            this.bindModel({modelPath : "agent.numOfActiveEngagements", callback : this.numOfActiveEngagementsUpdated});
            this.bindModel({modelPath : "agent.chatsResumedCount", callback : this.handleChatsResumed});

            this.viewEventsHandler.bindEvent({appName : TabsManagerViewController.applicationType, UIEvent : this.eventType.VISITOR_FOCUSED, callback : this.visitorTablesFocused});
            this.viewEventsHandler.bindEvent({appName : TabsManagerViewController.applicationType, UIEvent : this.eventType.VISITOR_BLURRED, callback : this.visitorBlurred});
            this.viewEventsHandler.bindEvent({appName : "webAgent" , UIEvent : this.eventType.TOUCH_SESSION, callback : this.applyTouchSessionMethod});

            var channel = webAgentStatics.COMMUNICATION_CHANNELS.QUEUE_ORB;
            lpTag.WebAgent.channel.bind(channel.name, channel.events.acceptSuccess, this.onAcceptSuccess.bind(this));
        },

        render: function () {
            this.addClass(this.view, 'loadingMain');
        },

        postInitialization: function () {
            this.header = new HeaderViewController({
                modelController: this.modelController
                //templateFile : "LP_KPI.html",
                //styleFile : "LP_KPI.css"
            });
            this.addPhotoPreviewView();
            this.engagementsArea = new EngagementAreaViewController({
                modelController: this.modelController,
                autoLogin: this.autoLogin,
                templateFile: "LP_engagements_area.html"
            });
            this.footer = new FooterViewController({
                modelController: this.modelController,
                templateFile: "LP_footer_widget.html"
            });

            this.addViewController({viewController : this.engagementsArea, target : this.fragmentDocument});
            this.addViewController({viewController : this.footer, target : this.fragmentDocument});

            this.bindModel({modelPath : "agent.connectionState", callback : this.handleConnectionState});
            this.bindModel({modelPath: 'amsService.socketState', callback: this.handleAmsConnectionState});
        }
    });

    MainViewController.prototype.addPhotoPreviewView = function () {
        this.PhotoPreviewView = new PhotoPreviewViewController({
            modelController: this.modelController,
            wrapWithDiv: false
        });
        window.App.PhotoPreviewView = this.PhotoPreviewView;
        this.addViewController({viewController : this.PhotoPreviewView, target : this.fragmentDocument});
    };

    MainViewController.prototype.engagementStates = {
        active: "active",
        inactive: "inactive",
        completed: "completed"
    };

    MainViewController.prototype.numOfActiveEngagementsUpdated = function (data) {
        if (typeof data.newValue !== "undefined") {
            this.numOfActiveEngagements = parseInt(data.newValue, 10);
            this.setShortcutRegistration(this.numOfActiveEngagements > 0);
        }
    };

    MainViewController.prototype.createVisitorTables = function () {
        if (!this.tabsManagerVC || this.tabsManagerVC.disposed) {
            this.tabsManagerVC = new TabsManagerViewController({
                templateFile: "LP_tabs_manager.html",
                modelController: this.modelController,
                className: "tabs_manager_main_wrapper"
            });
            this.addViewController({viewController : this.tabsManagerVC, target : this.fragmentDocument});
        }
    };

    MainViewController.prototype.handleChatsResumed = function (data) {
        if (typeof data.newValue !== 'undefined') {
            this.appendFragmentDocument();
            if (data.newValue === 0) {
                this.fireFocusOnDefaultElement();
            }
        }
    };

    MainViewController.prototype.appendFragmentDocument = function () {
        if (this.fragmentDocument) {
            this.view.appendChild(this.fragmentDocument);
            this.fragmentDocument = null; // deleting the fragment document after the append to make sure that if more VC's will be added, they will be added to this.view.
            this.removeClass(this.view, 'loadingMain');
        }
    };

    MainViewController.prototype.setShortcutRegistration = function (register) {
        if (register != this.shortcutRegistered) {
            this.shortcutRegistered = register;
            var functionName = register ? "registerShortcut" : "unregisterShortcut";
            if (this.supportShortcuts) {
                this[functionName](this.shortcutType.FOCUS_TOGGLING_NEXT, this.engagementShortcut);
                this[functionName](this.shortcutType.FOCUS_TOGGLING_BACK, this.engagementShortcut);
            }
        }
    };

    MainViewController.prototype.engagementShortcut = function (e) {
        if (this.participants.length === 0) {
            return;
        }

        var currentFocusedIndex = this.getFocusedVisitorIndex();
        // if the current engagement is inactive, we set the index of current to participants length, this is done to
        // simulate an index out of scope with the relative position of the offline orb
        if (!this.participants[currentFocusedIndex].active) {
            currentFocusedIndex = this.participants.length;
        }
        var newFocusIndex = this.getNextVisitorToFocusIndex(currentFocusedIndex, !e.event.shiftKey);
        if (newFocusIndex != -1) {
            this.viewEventsHandler.fireEvent({appName : this.participants[newFocusIndex].visitorId, UIEvent : this.eventType.VISITOR_FOCUSED});
        }

        return "Continue Holding"; // It doesn't matter what to return here, just return something for the shortcuts to keep alive.
    };

    MainViewController.prototype.getFocusedVisitorIndex = function () {
        var currentFocusedIndex = 0; // If no focused index received, setting the first engagement in focus. (Visitors List toggled)
        for (var i = 0; i < this.participants.length; i++) {
            if (this.participants[i].visitorId == this.focusQueue[this.focusedIndex]) {
                currentFocusedIndex = i;
            }
        }
        return currentFocusedIndex;
    };

    MainViewController.prototype.getNextVisitorToFocusIndex = function (currentFocusedIndex, goForward) {
        if (this.numOfActiveEngagements === 0) {
            return -1;
        }
        var nextFocusIndex = currentFocusedIndex;
        var indexFound = false;
        var engagementsCounter = this.participants.length; // to make sure we don't loop over the array more than one time
        while (engagementsCounter > 0 && !indexFound) {
            nextFocusIndex += (goForward ? 1 : -1);
            if (nextFocusIndex < 0) {
                nextFocusIndex = this.participants.length - 1;
            } else if (nextFocusIndex >= this.participants.length) {
                nextFocusIndex = 0;
            }
            if (this.participants[nextFocusIndex].active) {
                indexFound = true;
            }
            engagementsCounter--;
        }
        return nextFocusIndex;
    };

    MainViewController.prototype.handleNewParticipant = function (data) {
        var visitors = Object.keys(data.newValue);
        for (var visitor in visitors) {
            var visitorId = visitors[visitor];
            this.handleSingleNewParticipant(visitorId);
        }
    };

    MainViewController.prototype.handleSingleNewParticipant = function (visitorId) {
        var newParticipant = true;
        for (var i = 0; i < this.participants.length; i++) {
            if (this.participants[i].visitorId == visitorId) {
                newParticipant = false;
            }
        }
        if (newParticipant) {
            this.participants.push({visitorId: visitorId});
        }

        this.viewEventsHandler.bindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_FOCUSED, callback : this.visitorFocused});
        this.viewEventsHandler.bindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_BLURRED, callback : this.visitorBlurred});
        this.viewEventsHandler.bindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_DISPOSED, callback : this.visitorDisposed});

        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
        this.bindModel({modelPath : participantPath + '.participantState.engagementState', callback : this.handleEngagementStateChanged});
        this.bindModel({modelPath : participantPath + '.participantInfo.acceptedEngagement', callback : this.handleNewAcceptedEngagement});
        this.bindModel({modelPath : participantPath + '.participantInfo.spectatedEngagement', callback : this.handleNewSpectatedEngagement});
    };

    MainViewController.prototype.onAcceptSuccess = function (data) {
        if (data && data.visitorId && data.chatId) {
            var visitorId = data.visitorId;
            var newParticipant = true;
            for (var i = 0; i < this.participants.length; i++) {
                if (this.participants[i].visitorId == visitorId) {
                    newParticipant = false;
                }
            }
            if (newParticipant) {
                this.participants.push({visitorId: visitorId, active: true});
            }

            this.viewEventsHandler.bindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_FOCUSED, callback : this.visitorFocused});
            this.viewEventsHandler.bindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_BLURRED, callback : this.visitorBlurred});
            this.viewEventsHandler.bindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_DISPOSED, callback : this.visitorDisposed});

            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
            this.bindModel({modelPath : participantPath + '.participantState.engagementState', callback : this.handleEngagementStateChanged});

            this.asyncMessaging = data.isAsyncMessaging;
            this.autoAnswering = data.isAutoAccepted;
            this.setAcceptedOrSpectated(true);
            this.fireFocusOnVisitor(visitorId);
        }
    };

    MainViewController.prototype.handleEngagementStateChanged = function (data) {
        var visitorId = data.key.split(".")[2];
        switch (data.newValue) {
            case this.engagementStates.inactive:
            case this.engagementStates.completed:
                this.markParticipant(visitorId, false);
                break;
            case this.engagementStates.active:
                this.markParticipant(visitorId, true);
                this.handleEngagementActive(visitorId);
                break;
        }
    };

    MainViewController.prototype.markParticipant = function (visitorId, active) {
        for (var i = 0; i < this.participants.length; i++) {
            if (this.participants[i].visitorId == visitorId) {
                this.participants[i].active = active;
            }
        }
    };

    MainViewController.prototype.visitorTablesFocused = function (data) {
        this.createVisitorTables();
        this.visitorFocused(data);
    };

    MainViewController.prototype.visitorFocused = function (data) {
        var visitorId = data && data.newValue && data.newValue .appName;
        if (!visitorId || this.focusedVisitorId === visitorId) {
            return;
        }
        this.focusedVisitorId = visitorId;

        var blurredVisitorId;

        if (this.focusedIndex === -1) {
            this.logger.info("", 'visitorFocused', data.newValue);
            this.focusQueue.push(this.focusedVisitorId);
            this.focusedIndex++;
        } else if (this.focusQueue[this.focusedIndex] != this.focusedVisitorId) {
            blurredVisitorId = this.focusQueue[this.focusedIndex];
            if (this.focusedIndex === this.focusQueue.length - 1) {
                this.focusQueue.push(this.focusedVisitorId);
            }
            this.focusedIndex++;
            this.logger.info("", 'visitorFocused', data.newValue);
            this.viewEventsHandler.fireEvent({appName : blurredVisitorId, UIEvent : this.eventType.VISITOR_BLURRED});
        }
        this.hidePhotoView();
    };

    MainViewController.prototype.hidePhotoView = function () {
        this.PhotoPreviewView.hideView();
    };

    MainViewController.prototype.visitorBlurred = function (data) {
        if (typeof data.newValue === 'undefined') {
            return;
        }

        var visitorId = data.newValue.appName;

        if (this.focusedIndex >= 0 && (this.focusQueue[this.focusedIndex] == visitorId)) { //using the '==' instead of '===' : one of the the values is represented by string(from the model), and the other by integer
            this.focusedIndex--;
        }
        if (this.focusedIndex >= 0) {
            this.viewEventsHandler.fireEvent({appName : this.focusQueue[this.focusedIndex], UIEvent : this.eventType.VISITOR_FOCUSED});
        } else {
            this.fireFocusOnDefaultElement();
        }
    };

    MainViewController.prototype.visitorDisposed = function (data) {
        if (typeof data.newValue == 'undefined') {
            return;
        }
        var visitorId = data.newValue.appName;
        var focusedVisitorId = this.focusQueue[this.focusedIndex];

        if(this.focusQueue.indexOf(visitorId) !== -1){removeVisitorFromFocusQueue(this, visitorId, focusedVisitorId);
        this.viewEventsHandler.fireEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_BLURRED});
        removeVisitorFromParticipantObj(this, visitorId);}

        this.viewEventsHandler.disposeEventData(visitorId);

        function removeVisitorFromParticipantObj(context, visitorId) {
            for (var i = 0; i < context.participants.length; i++) {
                if (context.participants[i].visitorId == visitorId) {
                    context.participants.splice(i, 1);
                }
            }
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
            context.unbindModel({modelPath : participantPath + '.participantState.engagementState', callback : context.handleEngagementStateChanged});
            context.unbindModel({modelPath : participantPath + '.participantInfo.acceptedEngagement', callback : context.handleNewAcceptedEngagement});
            context.unbindModel({modelPath : participantPath + '.participantInfo.spectatedEngagement', callback : context.handleNewSpectatedEngagement});

            context.viewEventsHandler.unbindEvent({appName : visitorId, UIEvent : context.eventType.VISITOR_FOCUSED, callback : context.visitorFocused});
            context.viewEventsHandler.unbindEvent({appName : visitorId, UIEvent : context.eventType.VISITOR_DISPOSED, callback : context.visitorDisposed});
            context.viewEventsHandler.unbindEvent({appName : visitorId, UIEvent : context.eventType.VISITOR_BLURRED, callback : context.visitorBlurred});
        }

        function removeVisitorFromFocusQueue(context, disposedVisitorId, focusedVisitorId) {
            var newArray = [];
            for (var j = 0; j < context.focusQueue.length; j++) {
                if (context.focusQueue[j] != disposedVisitorId) {   //using the '==' instead of '===' : one of the the values is represented by string(from the model), and the other by integer
                    newArray.push(context.focusQueue[j]);
                }
            }
            context.focusQueue = newArray;

            if (disposedVisitorId == focusedVisitorId) {
                context.focusedIndex = newArray.length - 1;
            } else { // Looking up the focused visitor Id again after cleaning the queue.
                for (var i = 0; i < context.focusQueue.length; i++) {
                    if (context.focusQueue[i] == focusedVisitorId) {
                        context.focusedIndex = i;
                    }
                }
            }
        }
    };

    MainViewController.prototype.statusChanged = function (data) {
        if (typeof data.newValue != 'undefined' && data.newValue !== 'loggedIn') {
            for (var index = 0; index < this.participants.length; index++) {
                var visitorId = this.participants[index].visitorId;
                this.viewEventsHandler.unbindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_FOCUSED, callback : this.visitorFocused});
                this.viewEventsHandler.unbindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_DISPOSED, callback : this.visitorDisposed});
                this.viewEventsHandler.unbindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_BLURRED, callback : this.visitorBlurred});
            }
            this.participants = [];
            this.focusQueue = [];
            this.focusedIndex = -1;
        }
    };

    MainViewController.prototype.handleConnectionState = function (data) {
        data = data || {};
        switch (data.newValue) {
            case 'active':
                this.hideNotification();
                break;
            case 'notify':
                this.showConnectionIssuesNotification();
                break;
        }
    };

    MainViewController.prototype.handleAmsConnectionState = function (data) {
        data = data || {};
        switch (data.newValue) {
            case 'connected':
            case 'recovered':
                if (this.nonResponsiveTimeoutId) {
                    clearTimeout(this.nonResponsiveTimeoutId);
                    this.nonResponsiveTimeoutId = null;
                }
                this.hideNotification();
                break;
            case 'closed':
            case 'non_responsive':
                if (!this.notifier && !this.nonResponsiveTimeoutId) {
                    // todo - should this be the responsibility of amsController?
                    this.nonResponsiveTimeoutId = setTimeout(function () {
                        this.showConnectionIssuesNotification();
                    }.bind(this), lpTag.WebAgent.logicController.isNonResponsivenNotifyTime() || 10000);
                }
                break;
        }
    };

    MainViewController.prototype.showConnectionIssuesNotification = function () {
        // If a notifier already exists, don't create a new one
        if (!this.notifier) {
            var notifierLE = agentLEManager.notifierLE();
            if (notifierLE && notifierLE.showWarningNoClose) {
                this.notifier = notifierLE.showWarningNoClose({
                    content: this.translate('pleaseWait'),
                    persist: true,
                    disableClickToClose: true,
                    top: 226 // distance from the top of the page in px, where to be rendered
                });
            }
        }
    };

    MainViewController.prototype.hideNotification = function () {
        if (this.notifier && this.notifier.close) {
            this.notifier.close();
            this.notifier = null;
        }
    };

    MainViewController.prototype.applyTouchSessionMethod = function () {
        if (this.touchSessionMethod) {
            this.touchSessionMethod();
        }
    };

    MainViewController.prototype.handleNewAcceptedEngagement = function (data) {
        if (!data.newValue) {
            return;
        }
        this.setAcceptedOrSpectated(true);
        var visitorId = data.key.split('.')[2];
        this.fireFocusOnVisitor(visitorId);
    };

    MainViewController.prototype.handleNewSpectatedEngagement = function (data) {
        if (!data.newValue) {
            return;
        }
        this.setAcceptedOrSpectated(false);
        var visitorId = data.key.split('.')[2];
        this.fireFocusOnVisitor(visitorId);
    };

    MainViewController.prototype.handleEngagementActive = function (visitorId) {
        if (lpTag.WebAgent.logicController.isAcceptedEngagement(visitorId)) {
            this.setAcceptedOrSpectated(true);
            this.fireFocusOnVisitor(visitorId);
        }
    };

    MainViewController.prototype.setAcceptedOrSpectated = function (isAccepted) {
        this.acceptedEngagement = isAccepted;
        this.spectatedEngagement = !isAccepted;
    };

    MainViewController.prototype.fireFocusOnDefaultElement = function () {
        this.viewEventsHandler.fireEvent({appName : TabsManagerViewController.applicationType, UIEvent : this.eventType.VISITOR_FOCUSED});
    };

    MainViewController.prototype.fireFocusOnVisitor = function (visitorId) {
        if (this.shouldFocusOnVisitor(visitorId)) {
            this.viewEventsHandler.fireEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_FOCUSED});
        }
    };

    MainViewController.prototype.logout = function () {
        if (lpTag.WebAgent.logicController.logoutMethod) {
            lpTag.WebAgent.logicController.logoutMethod(true);
        } else {
            this.showDialog({
                title: this.translate("signoutTitle"),
                description: this.translate("signoutDescription"),
                okButton: this.translate("signOut"),
                cancelButton: this.translate("cancel"),
                okCallback: this.modelController.logOutAgent,
                targetView: window.MainViewControllerBody,
                modal: true
            });
        }
    };

    MainViewController.prototype.shouldFocusOnVisitor = function (visitorId) {
        if (visitorId) {
            this.asyncMessaging = lpTag.WebAgent.logicController.isVisitorAsyncMessaging(visitorId);
            this.isAutoOpenConversation = lpTag.WebAgent.logicController.isAutoOpenConversation(visitorId);
        }
        return (!this.asyncMessaging && this.spectatedEngagement) ||
            (!this.autoAnswering && !this.isAutoOpenConversation) ||
            !this.focusedVisitorId ||
            this.focusedVisitorId === TabsManagerViewController.applicationType;
    };

    return MainViewController;

});
